import React, { useEffect, useState } from "react";
import "./Orders.css";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { SearchFilter } from "../../components/SearchFilter/SearchFilter";
import * as GrIcons from "react-icons/gr";
import { DataLoader } from "../../utils/DataLoader";
import { GetOrderStatus } from "../../apis/MiscAPI";

export default function AdminOrders() {
  const ControllerNActionName = {
    ControllerName: "Order",
    ActionName: "getallorders",
    SearchField:"order_id"
  };
  const [orders, setOrders] = useState({
    data: [],
    total: 77,
  });
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    filter: "0",
  });
  const [orderStatuses, setOrderStatuses] = useState([]);
  const handleSearch = async (searchValue) => {
    localStorage.setItem("searchData", true);
    setDataState({ take: 50, skip: 0, filter: searchValue});
  };
  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };
  const dataReceived = (orders) => {
    setOrders(orders);
  };
  const initialSort = [
    {
      field: "isnull(order_update_timestamp,order_timestamp)",
      dir: "desc",
    },
  ];
  const [count, setCount] = useState(1);
  const [sort, setSort] = React.useState(initialSort);
  const handleSorting = (e) =>{
    localStorage.setItem("sortData", true);
    let sortingArray = e.sort;
    sortingArray.forEach((element, i) => {
     if(element.field === "id"){
         e.sort[i].field = "order_id";
         e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
        }
     else if(element.field === "orderStartDate"){
         e.sort[i].field = "order_start_date";
         e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
     }
     else if(element.field === "orderCustomerName"){
      e.sort[i].field = "customer_name";
      e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
    }
    else if(element.field === "requestorName"){
      e.sort[i].field = "requestor_name";
      e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
    }
    else if(element.field === "orderApplicantName"){
      e.sort[i].field = "order_applicant_name";
      e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
    }
    else if(element.field === "orderPo"){
      e.sort[i].field = "order_po";
      e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
    }
    else if(element.field === "investigatorName"){
      e.sort[i].field = "investigator_name";
      e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
    }
    else if(element.field === "orderStatusName"){
      e.sort[i].field = "order_status_name";
      e.sort[i].dir = (count%2 == 0 ? "desc" : "asc");
    }
    });
    setCount(count + 1);
    setSort(e.sort);
  }
  const handleAdvanceSearch = async (searchData) => {
    console.log(searchData);
    let submissionSearch = false;
    let completionSearch = false;
    if (
      searchData.submissionStartDate !== "" &&
      searchData.submissionEndDate !== ""
    )
      submissionSearch = true;
    if (
      searchData.completionStartDate !== "" &&
      searchData.completionEndDate !== ""
    )
    completionSearch = true;

    let searchBody = {
      isAdvanceSearch: "yes",
      submission_start_date:
        submissionSearch === true ? searchData.submissionStartDate : "",
      submission_end_date:
        submissionSearch === true ? searchData.submissionEndDate : "",
      completion_start_date:
        completionSearch === true ? searchData.completionStartDate : "",
      completion_end_date:
        completionSearch === true ? searchData.completionEndDate : "",
      applicant_name: searchData.applicantName,
      status:
        searchData.orderStatus.statusId === 0
          ? ""
          : "" + searchData.orderStatus.statusId,
    }
    localStorage.setItem("searchData", true);
    console.log(searchBody);
    setDataState({ take: 50, skip: 0, filter: searchBody });
  };
  useEffect(() => {
    async function GetOrderStatuses(){
      var result = await GetOrderStatus();
      setOrderStatuses(result.data);
    }
    GetOrderStatuses();
  },[]);

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Orders</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter">
                      <SearchFilter
                        search={handleSearch}
                        orderStatuses={orderStatuses}
                        advSearch={handleAdvanceSearch}
                        requestorid={0}
                        investigatorid={0}
                        displayShort={false}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                <Grid
                    sortable={true}
                    sort={sort}
                    onSortChange={(e) => {
                      handleSorting(e);
                    }}
                    pageable={true}
                    {...dataState}
                    data={orders}
                    onDataStateChange={dataStateChange}
                    style={{ height: "75vh" }}
                  >
                    <Column field="id" title="Order No" width="100px" headerClassName="icon" />
                    <Column field="orderStartDate" title="Date" />
                    <Column field="orderCustomerName" title="Customer" />
                    <Column field="requestorName" title="Requestor" />
                    <Column field="orderApplicantName" title="Applicant" />
                    <Column field="orderPo" title="RE/PO Number" />
                    <Column
                      field="investigatorName"
                      title="Investigator"
                      width="120px"
                    />
                    <Column
                      field="orderStatusName"
                      title="Order Status"
                      width="100px"
                    />
                    <Column 
                      sortable={false}
                      field="id"
                      title="Details"
                      width="100px"
                      cell={(props) => (
                        <td>
                          <a
                            href={"/Admin/OrderDetail?id=" + props.dataItem.id}
                            className="ordtl"
                          >
                            <GrIcons.GrFormView />
                          </a>
                        </td>
                      )}
                    ></Column>
                  </Grid>
                  <DataLoader
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    dataItem={ControllerNActionName}
                    dataSort={sort}
                  />
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
